<div class="slidepop" [ngClass]="{'open': showSidePanel}">
  
    <div class="slidecontent">
      <div *ngIf="showcreateForm">
        <app-create-user
        (closeSidePanel)="closeSidePanel($event)">
      </app-create-user>
      </div>
      <div *ngIf="showeditForm">
        <app-edit-user (closeSidePanel)="closeSidePanel($event)">
          </app-edit-user>
      </div>     
    </div>   
  </div>


  <mat-card class="filter">
    <div class="sort_layout" fxLayout="row" fxLayoutAlign="start center">
      <h3>Users</h3>
    </div>

    <div class="actbtn" *ngIf="showAdd == true">
      <button mat-flat-button color="primary" (click)="addUsers()">
        Add User
      </button>
    </div>
  </mat-card>

    <div class="content-card">
            <app-table id="SDSAppTable"
                        [downloadFileName]="'UserList'" [totalCount]="totalCount"
                        [pageIndex]="pageIndex" [pageSize]="pageSize"
                        [displayedColumns]="sendDisplayedColumns" [showColumnNames]="showColumnNames"
                        [targetList]="userData"  [modulename]="Module" [clickableColumns]="clickableColumns" [showBadge]="showBadge"
                        (editObject)="openEditDialogData($event)" (pageChangeEvent)=CallNextPrevPageData($event)
                        (exportToExcel)="exportAsXLSX()">
                    </app-table>
        </div>
<app-loader></app-loader>


